import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Flex, Table, Tbody, Th, Thead, Tr, useColorModeValue } from "@chakra-ui/react";
import axios from "axios";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ModeloItemOrcamentoCategoria } from "models/modelo_item_orcamento_categoria";
import { ModeloItemOrcamentoItens } from "models/modelo_item_orcamento_itens";
import { ProductType } from "models/product_type";
import { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import useMeasureUnit from "../../measureUnit/hooks/useMeasureUnit";
import FormProduto from "../../product/components/Form";
import useProductOrder from "../../product/hooks/useProductOrder";
import DynamicAddItem from "./DynamicAddItem";
import DynamicRowItem from "./DynamicRowItem";

interface IDynamicTable {
    item: ModeloItemOrcamentoCategoria | undefined;
    borderColor: string;
    index: number;
    changeItem1: (item: ModeloItemOrcamentoCategoria) => void;
    isDragable: (drag: boolean) => void;
    condicaoPagamento: CondicaoPagamento[] | undefined;
}

const DynamicTable = ({item, borderColor, index, changeItem1, isDragable, condicaoPagamento} : IDynamicTable) => {
    const cancelRef1 = useRef(null);
    const [error, setError] = useState(false);
    const [categoryItens, setCategoryItens] = useState<ModeloItemOrcamentoItens[]>([]);
    const [produtos, setProdutos] = useState<ProductType[]>([]);
    const [errorTitle, setErrorTitle] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
  
  
    const editItem = (data: ModeloItemOrcamentoItens, tipo: string, value: string) => {
      switch (tipo) {
        case "produto":
  
          const existe = item.ModeloOrcamentoItemList.find((a => a.produtoId === value));
  
          if(existe) { 
            showError('Erro!','Produto já está na lista, procure editar esse produto!');
          } else {     
            item.ModeloOrcamentoItemList = item.ModeloOrcamentoItemList.map((findItem) => {
              if (data.descricao === findItem.descricao) {
                const novoProduto =  produtos?.find((a => a.id === value));
                const unidadePricipal = novoProduto?.ProdutoUnidade.find((b => b.principal));
                const unidadeSecundaria = novoProduto?.ProdutoUnidade[0];
                const valorMedioPrincipal =  (Number(novoProduto?.ProdutoUnidade.find((b => b.principal))?.valorMin) + Number(novoProduto?.ProdutoUnidade?.find((b => b.principal))?.valorMax) / 2);
                const valorMedioSecundario =  (Number(novoProduto?.ProdutoUnidade[0].valorMin) + Number(novoProduto?.ProdutoUnidade[0].valorMax) / 2);
                findItem.produtoId = novoProduto.id;
                findItem.produtoNome = novoProduto.nome;
                findItem.descricao = novoProduto.nome;
                findItem.unidadeMedidaId = unidadePricipal?.unidadeMedidaId ?? unidadeSecundaria?.unidadeMedidaId;
                findItem.produtoUnidadeId = unidadePricipal?.id ?? unidadeSecundaria.id;
                findItem.unidadeNome = unidades?.find((a) => a.id === unidadePricipal?.unidadeMedidaId)?.nome ?? unidades?.find((a) => a.id === unidadeSecundaria?.unidadeMedidaId)?.nome;
                findItem.valorUn = valorMedioPrincipal ?? valorMedioSecundario;
                findItem.valorTotal = findItem.quantidade *  findItem.valorUn;
                findItem.produtoUnidade =  novoProduto.ProdutoUnidade;     
            }
  
              return findItem;
            });
          }
          break;
  
        case "descricao":
          item.ModeloOrcamentoItemList = item.ModeloOrcamentoItemList.map((findItem) => {
            if (data.descricao === findItem.descricao) {
              findItem.descricao = value;
            }
            return findItem;
          });
          break;
  
        case "unidade":
          item.ModeloOrcamentoItemList = item.ModeloOrcamentoItemList.map((findItem) => {
            if (data.descricao === findItem.descricao) {
              const novoProduto =  produtos.find((a => a.id === findItem.produtoId));
              const selectedUnidade = novoProduto.ProdutoUnidade.find((a => a.unidadeMedidaId === value));
  
              if(selectedUnidade) {
                const valorMedio  = (Number(selectedUnidade.valorMin) + Number(selectedUnidade.valorMax)) / 2
                findItem.produtoUnidadeId = value;
                findItem.valorUn = valorMedio;
                findItem.valorTotal =  valorMedio * findItem.quantidade;
              }
  
            }
            return findItem;
          });
          break;
  
        case "quantidade":
          item.ModeloOrcamentoItemList = item.ModeloOrcamentoItemList.map((findItem) => {
            if (data.descricao === findItem.descricao) {
              findItem.quantidade = Number(value);
              findItem.valorTotal = Number(value) * findItem.valorUn;
            }
            return findItem;
          });
          break;
  
        case "valor":
          item.ModeloOrcamentoItemList = item.ModeloOrcamentoItemList.map((findItem) => {
            if (data.descricao === findItem.descricao) {
              let valor =  Number(value);
              const unidadeProduto =  findItem.produtoUnidade.find((a) => a.unidadeMedidaId === findItem.unidadeMedidaId);
              const valorToCompare =  Number(value);
              if(valorToCompare < unidadeProduto.valorMin) {
                showError('Erro!', 'Valor menor que o valor minímo cadastrado para esse item');
                valor =  unidadeProduto.valorMin;
              } 
              if(valorToCompare > unidadeProduto.valorMax) {
                showError('Erro!', 'Valor maior que o valor máximo cadastrado para esse item');
                valor =  unidadeProduto.valorMax;
              }
  
              findItem.valorUn = valor;
              findItem.valorTotal = valor * findItem.quantidade;
            }
            return findItem;
          });
          break;
  
        default:
          break;
      }
      item.valor = calculaValor(item.ModeloOrcamentoItemList);
      changeItem1(item);
      setCategoryItens(item.ModeloOrcamentoItemList);
  
  
    };
  
    const deleteRow1 = (value: ModeloItemOrcamentoItens) => {
      let list = categoryItens;
      const data = list.filter((data) => data.produtoId !== value.produtoId);
      item.valor = calculaValor(data);
      list = data;
      item.ModeloOrcamentoItemList = list;
      setCategoryItens(list);
      changeItem1(item);
    };
  
    const calculaValor = (data: ModeloItemOrcamentoItens[]) => {
      let soma = 0;
      data.forEach((item) => {
        soma = soma + Number(item.valorTotal);
      });
      return soma;
    };
    const {
      cancelRef,
      changeNome,
      accountSelected,
      nome,
      loading,
      save,
      show,
      showModal,
      addRow,
      changeItem,
      deleteRow,
      itens,
    } = useProductOrder();
    const { unidades } = useMeasureUnit();
  
    const closeError = () => {
      setError(false);
    };
  
    const onDragEnd = (result: any) => {
      reorder(item, result.source.index, result.destination.index);
    };
  
    const onDragStart = () => {
      isDragable(false);
    };
  
    const reorder = (
      list: ModeloItemOrcamentoCategoria,
      startIndex: number,
      endIndex: number
    ) => {
      const result = Array.from(list.ModeloOrcamentoItemList);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      item.valor = calculaValor(result);
      item.ModeloOrcamentoItemList = result;
      setCategoryItens(result);
      changeItem1(item);
    };
  
    const showError = (title: string, msg: string) => {
      setError(true);
      setErrorTitle(title);
      setErrorMsg(msg);
    };
  
    const saveNew = () => {
      if(itens.length > 0) {
        save()
      } else {
        showError('Erro!', 'Você deve selecionar ao menos uma unidade de medida')
      }
  
    }
  
  
    useEffect(() => {
      const loadData = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/produto/list/" + userData?.idEmpresa
        );
        if (response.data) {
          setProdutos(response.data);
  
        }
      }
      
      const loadItens = () => {
        if (item?.ModeloOrcamentoItemList?.length > 0) {
          setCategoryItens(item.ModeloOrcamentoItemList);
        }
      };
  
  
      loadItens();
      loadData();
    }, [item.ModeloOrcamentoItemList]);
  
    useEffect(() => {}, [itens, categoryItens])
  
  
    const textColor = useColorModeValue("navy.700", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");
  
    return (
      <>
        <Table
          variant="striped"
          color="gray.500"
          mb="24px"
          mt="12px"
          key={`${index}`}
        >
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #ITEM
                </Flex>
              </Th>
  
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #DESCRICAO
                </Flex>
              </Th>
  
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #UNIDADE
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #QTD
                </Flex>
              </Th>
  
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #VALOR UN
                </Flex>
              </Th>
  
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #TOTAL
                </Flex>
              </Th>
  
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #OPÇÕES
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <DynamicAddItem 
              calculaValor={calculaValor}
              changeItem1={changeItem1}
              index={index}
              item={item}
              produtos={produtos}
              setCategoryItens={setCategoryItens}
              setError={setError}
              setErrorMsg={setErrorMsg}
              setErrorTitle={setErrorTitle}
            />
          </Tbody>
        </Table>
  
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
          <Droppable droppableId="droppableItem">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ width: "100%" }}
              >
                {provided.placeholder}
  
                {categoryItens?.map((item1, index1) => {
                  return (
                    <DynamicRowItem 
                      deleteRow1={deleteRow1}
                      editItem={editItem}
                      index={index}
                      index1={index1}
                      item1={item1}
                      produtos={produtos}
                      unidades={unidades}
                    />
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
  
        <AlertDialog
          isOpen={error}
          leastDestructiveRef={cancelRef1}
          onClose={closeError}
          isCentered
          motionPreset="slideInBottom"
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {errorTitle}
              </AlertDialogHeader>
  
              <AlertDialogBody>{errorMsg}</AlertDialogBody>
  
              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                  OK
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
  
        <FormProduto
          accountSelected={accountSelected}
          brandStars={brandStars}
          error={error}
          loading={loading}
          nome={nome}
          changeNome={changeNome}
          save={saveNew}
          show={show}
          showModal={showModal}
          textColor={textColor}
          changeItem={changeItem}
          deleteRow={deleteRow}
          addRow={addRow}
          borderColor={borderColor}
          itens={itens}
          errorMsg={errorMsg}
          errorTitle={errorTitle}
          cancelRef={cancelRef}
          closeError={closeError}
          condicaoPagamentos={condicaoPagamento}
        />
      </>
    );
  };
export default DynamicTable;